import { useDatePickerContext } from '../context';
import { CalendarObj, PanelView } from '../types';
import { Calendar } from './Calendar';
import { Header } from './Header';
import { Month } from './Month';
import { Week } from './Week';
import { Year } from './Year';

type CalendarPanelProps = {
  calendar: CalendarObj;
  panelState: PanelView;
  'data-testid'?: string;
};

export const CalendarPanel = ({ calendar, panelState, 'data-testid': dataTestId }: CalendarPanelProps) => {
  const { calendarState } = useDatePickerContext();

  return (
    <div data-testid={dataTestId} className='right-picker relative w-full overflow-hidden mt-3'>
      <Header panel={panelState} calendar={calendar} />

      <div className='calendar-wrapper px-0.5'>
        {panelState === PanelView.Month && <Month months={calendarState.months} updateMonth={calendar.setMonth} />}

        {panelState === PanelView.Year && <Year years={calendar.years()} setYear={calendar.setYear} />}

        {panelState === PanelView.Calendar && (
          <>
            <Week />
            <Calendar calendar={calendar} />
          </>
        )}
      </div>
    </div>
  );
};
